// extracted by mini-css-extract-plugin
export default {"content":"Preloader_content__QxQlR","container__loader":"Preloader_container__loader__6Ta4x","loader":"Preloader_loader__v9kC2","spin":"Preloader_spin__64k+s"};